/**
 * @generated SignedSource<<310e792140dd76cce1f01703c65c09ec>>
 * @relayHash 02ae6d92fb43e7a981a8a669ef668053
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6999f04a3a7f23e282a1c635878ea041a2aab0f9e20b7d83bfdd89d2eedfd229

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6999f04a3a7f23e282a1c635878ea041a2aab0f9e20b7d83bfdd89d2eedfd229",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
